import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// 单值代码
import codeType from './modules/codeType';
import user from './modules/user';
import caseHandling from './modules/case-handling.js';
import caseCall from './modules/case-call.js';
import eventTracking from './modules/event-tracking';
import caseImport from './modules/case-import';
import docPageStatus from './modules/doc-page-status';
import nonLawsuit from './modules/non-lawsuit';
import judicialConfirmationDetail from './modules/judicial-confirmation-detail';
import yzwJudicialConfirmationDetail from './modules/yzw-judicial-confirmation-detail';
import formModule from './modules/form-module';
import longTask from './modules/long-task';
import brtManager from './modules/brt-ag';
// 埋点
import report from './modules/report';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    codeType,
    user,
    caseHandling,
    caseCall,
    eventTracking,
    caseImport,
    docPageStatus,
    nonLawsuit,
    judicialConfirmationDetail,
    yzwJudicialConfirmationDetail,
    // pageCatch,
    formModule,
    brtManager,
    report,
    longTask
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        user: val.user,
        caseImport: val.caseImport,
        nonLawsuit: val.nonLawsuit,
        caseCall: val.caseCall,
      };
    }
  })]
});
